import React from 'react';
import { ReactComponent as APPLE } from './apple.svg';
import { ReactComponent as BEE } from './bee.svg';
import { ReactComponent as CAFFEINE } from './caffeine.svg';
import { ReactComponent as CELERY } from './celery.svg';
import { ReactComponent as CITRUS } from './citrus.svg';
import { ReactComponent as CORN } from './corn.svg';
import { ReactComponent as CRUSTACEANS } from './crustaceans.svg';
import { ReactComponent as DAIRY } from './dairy.svg';
import { ReactComponent as EGGS } from './eggs.svg';
import { ReactComponent as FISH } from './fish.svg';
import { ReactComponent as GLUTEN } from './gluten.svg';
import { ReactComponent as LEGUMES } from './legumes.svg';
import { ReactComponent as LUPIN } from './lupin.svg';
import { ReactComponent as MILK_GOAT } from './milk_goat.svg';
import { ReactComponent as MILK_PACKAGING } from './milk_packaging.svg';
import { ReactComponent as MILK_UDDER } from './milk_udder.svg';
import { ReactComponent as MOLLUSCS } from './molluscs.svg';
import { ReactComponent as MUSHROOM } from './mushroom.svg';
import { ReactComponent as MUSTARD } from './mustard.svg';
import { ReactComponent as NUTS } from './nuts.svg';
import { ReactComponent as ORGANIC } from './organic.svg';
import { ReactComponent as PEANUT } from './peanut.svg';
import { ReactComponent as SEEDS } from './seeds.svg';
import { ReactComponent as SESAME } from './sesame.svg';
import { ReactComponent as SHELLFISH } from './shellfish.svg';
import { ReactComponent as SOY } from './soy.svg';
import { ReactComponent as SULPHITE } from './sulphite.svg';
import { ReactComponent as TREATMENTS } from './treatments.svg';
import { ReactComponent as TREE_NUTS } from './treenuts.svg';
import { ReactComponent as VEGAN } from './vegan.svg';
import { ReactComponent as WINE } from './wine.svg';
import styled, { css } from 'styled-components';
import clsx from 'clsx';

export enum ProductAllergenValue {
    APPLE = 'APPLE',
    BEE = 'BEE',
    CAFFEINE = 'CAFFEINE',
    CELERY = 'CELERY',
    CITRUS = 'CITRUS',
    CORN = 'CORN',
    CRUSTACEANS = 'CRUSTACEANS',
    DAIRY = 'DAIRY',
    EGGS = 'EGGS',
    FISH = 'FISH',
    GLUTEN = 'GLUTEN',
    LEGUMES = 'LEGUMES',
    LUPIN = 'LUPIN',
    MILK_GOAT = 'MILK_GOAT',
    MILK_PACKAGING = 'MILK_PACKAGING',
    MILK_UDDER = 'MILK_UDDER',
    MOLLUSCS = 'MOLLUSCS',
    MUSHROOM = 'MUSHROOM',
    MUSTARD = 'MUSTARD',
    NUTS = 'NUTS',
    ORGANIC = 'ORGANIC',
    PEANUT = 'PEANUT',
    SEEDS = 'SEEDS',
    SESAME = 'SESAME',
    SHELLFISH = 'SHELLFISH',
    SOY = 'SOY',
    SULPHITE = 'SULPHITE',
    TREATMENTS = 'TREATMENTS',
    TREE_NUTS = 'TREE_NUTS',
    VEGAN = 'VEGAN',
    WINE = 'WINE',
}

const colors = {
    [ProductAllergenValue.APPLE]: '#66cc33',
    [ProductAllergenValue.BEE]: '#c58f00',
    [ProductAllergenValue.CAFFEINE]: '#6f4e37',
    [ProductAllergenValue.CELERY]: '#afc151',
    [ProductAllergenValue.CITRUS]: '#9FB70A',
    [ProductAllergenValue.CORN]: '#fbec5d',
    [ProductAllergenValue.CRUSTACEANS]: '#a7210e',
    [ProductAllergenValue.DAIRY]: '#fdfff5',
    [ProductAllergenValue.EGGS]: '#f6e6d6',
    [ProductAllergenValue.FISH]: '#89c3ca',
    [ProductAllergenValue.GLUTEN]: '#f5deb3',
    [ProductAllergenValue.LEGUMES]: '#8eab12',
    [ProductAllergenValue.LUPIN]: '#a0b8de',
    [ProductAllergenValue.MILK_GOAT]: '#fdfff5',
    [ProductAllergenValue.MILK_PACKAGING]: '#fdfff5',
    [ProductAllergenValue.MILK_UDDER]: '#fdfff5',
    [ProductAllergenValue.MOLLUSCS]: '#cabcbc',
    [ProductAllergenValue.MUSHROOM]: '#d8ccc0',
    [ProductAllergenValue.MUSTARD]: '#ffdb58',
    [ProductAllergenValue.NUTS]: '#824432',
    [ProductAllergenValue.ORGANIC]: '#79b47c',
    [ProductAllergenValue.PEANUT]: '#824432',
    [ProductAllergenValue.SEEDS]: '#e4c89e',
    [ProductAllergenValue.SESAME]: '#d7bf99',
    [ProductAllergenValue.SHELLFISH]: '#cbabab',
    [ProductAllergenValue.SOY]: '#6F634B',
    [ProductAllergenValue.SULPHITE]: '#ffffbf',
    [ProductAllergenValue.TREATMENTS]: '#ffffff',
    [ProductAllergenValue.TREE_NUTS]: '#eadac2',
    [ProductAllergenValue.VEGAN]: '#79b47c',
    [ProductAllergenValue.WINE]: '#722f37',
};

const Wrapper: any = styled.span`
    height: ${(props: any) => props.size || '40px'};
    width: ${(props: any) => props.size || '40px'};
    display: inline-flex;

    ${Object.keys(colors).map(
        (allergen) => css`
            &.${allergen} {
                &,
                &:before,
                * {
                    fill: ${colors[allergen]};
                    border-color: ${colors[allergen]};
                }
            }
        `,
    )}
`;

const ALLERGEN = {
    APPLE,
    BEE,
    CAFFEINE,
    CELERY,
    CITRUS,
    CORN,
    CRUSTACEANS,
    DAIRY,
    EGGS,
    FISH,
    GLUTEN,
    LEGUMES,
    LUPIN,
    MILK_GOAT,
    MILK_PACKAGING,
    MILK_UDDER,
    MOLLUSCS,
    MUSHROOM,
    MUSTARD,
    NUTS,
    ORGANIC,
    PEANUT,
    SEEDS,
    SESAME,
    SHELLFISH,
    SOY,
    SULPHITE,
    TREATMENTS,
    TREE_NUTS,
    VEGAN,
    WINE,
};

interface Props {
    allergen: ProductAllergenValue | string;
    size?: string | number;
}

export function ProductAllergen({ allergen, size }: Props) {
    const Component = ALLERGEN[allergen];

    return Component ? (
        <Wrapper className={clsx('ProductAllergen', allergen)} size={size}>
            <Component />
        </Wrapper>
    ) : null;
}
